// src/features/more/ShareSheet.jsx
import { useState } from 'react';
import { BottomSheet } from '@components/ui';
import { shareApp } from '@services';
import { T } from '@components/theme';

const APP_URL = 'https://eyeonstorm.netlify.app';

export function ShareSheet({ open, onClose }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(APP_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  const options = [
    { icon: '💬', label: 'Text',  fn: () => window.open(`sms:?body=Stay safe with Eye on Storm - free emergency app for Louisiana: ${APP_URL}`) },
    { icon: '📧', label: 'Email', fn: () => window.open(`mailto:?subject=Eye on Storm&body=Emergency preparedness app for Louisiana: ${APP_URL}`) },
    { icon: '🔗', label: 'Copy',  fn: copy },
    { icon: '📱', label: 'Share', fn: shareApp },
  ];

  return (
    <BottomSheet open={open} onClose={onClose} maxH="55vh">
      <div style={{ padding: '8px 20px 24px' }}>
        <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>Share Eye on Storm</div>
        <div style={{ fontSize: 12, color: T.dim, marginBottom: 16 }}>Help your neighbors stay safe</div>

        {/* URL row */}
        <div style={{ background: T.bg2, borderRadius: 10, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, border: `1.5px solid ${T.bdr}` }}>
          <span style={{ fontSize: 13, flex: 1, color: T.text, fontWeight: 700 }}>
            eyeonstorm.netlify.app
          </span>
          <button
            onClick={copy}
            style={{ background: copied ? T.green : T.amber, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: T.font, flexShrink: 0 }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        {/* Share options grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {options.map((opt) => (
            <button
              key={opt.label}
              onClick={opt.fn}
              style={{ padding: '14px 10px', borderRadius: 10, border: `1.5px solid ${T.bdr}`, background: T.bg2, cursor: 'pointer', fontFamily: T.font, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}
            >
              <span style={{ fontSize: 26 }}>{opt.icon}</span>
              <span style={{ fontSize: 12, fontWeight: 700, color: T.text }}>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>
    </BottomSheet>
  );
}
